









































































import { Component, Vue, Prop } from "vue-property-decorator";
import QuestionImg from "@/components/question/question-img.vue";
import QuestionSelect from "@/components/question/question-select.vue";
import Empty from "@/components/empty.vue";
import {
  UploadFile,
  GetShixunZicaiList,
  AddZicai,
  DeleteZicai,
  GetCommit,
  GetTem,
  GetOptions,
} from "@/request/common";
@Component({
  components: {
    QuestionImg,
    QuestionSelect,
    Empty,
  },
})
export default class Name extends Vue {
  private questionIndex: any = null;
  private showAnswer: any = false;
  private maxH: any = null; // 图片的最大高度
  private data: any = [];
  private cTab: any = "";
  private get systemInfo() {
    console.log(this.$store.state.systemInfo);
    return this.$store.state.systemInfo;
  }

  private get user() {
    return this.$store.state.user;
  }
  private changeTab(val: any) {
    this.questionIndex = 0;
    this.cTab = this.systemInfo.SETTING.zicaiRange[val];
    this.getData();
  }
  private countHeight() {
    const box = (this.$refs.imgBox as any).offsetHeight;
    this.maxH = box;
  }
  private IndexChange(index: any) {
    this.questionIndex = index;
    this.getDetail();
  }
  private changeSelect(val: any) {
    this.data[this.questionIndex].ifSelect = val;
  }
  private jiexi() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      qts: this.data[this.questionIndex].data,
      template_type: this.data[this.questionIndex]["类别"],
    };
    GetCommit(this, params, loading)
      .then((res: any) => {
        const d: any = JSON.parse(JSON.stringify(this.data));
        d[this.questionIndex]["评语"] = res;
        d[this.questionIndex].ifShowAnswerJiexi = true;
        this.data = d;
        this.$forceUpdate();
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
    // AddZicai(this, this.data[this.questionIndex], loading)
    //   .then((res: any) => {
    //     loading.close();
    //   })
    //   .catch(() => {
    //     loading.close();
    //   });
  }
  private goBefore() {
    if (this.questionIndex == 0) {
      this.$message.warning("已经是第一题了");
      return;
    }
    this.questionIndex--;
    this.getDetail();
  }
  private goNext() {
    if (this.questionIndex == this.data.length - 1) {
      this.$message.warning("已经是最后一题了");
      return;
    }
    this.questionIndex++;
    this.getDetail();
  }
  private getData(type?: any) {
    if (!this.cTab || !this.cTab.name) {
      const type = this.systemInfo.SETTING.zicaiRange.keys[0];
      this.cTab = this.systemInfo.SETTING.zicaiRange[type];
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        类别: this.cTab.name,
      },
    };
    GetShixunZicaiList(this, params, loading)
      .then((res: any) => {
        loading.close();
        // 初始化参数，根据页面需求初始化
        // ifSelect 是否答题
        // ifShowEdit 是否可以编辑
        // ifShowCorrect 是否显示正确答案
        // ifShowAnswer 是否显示答案
        // ifShowAnswerBtn 是否显示答案按钮
        // ifShowAnswerResult 是否显示答案结果
        if (res.length == 0) {
          this.data = [];
          this.addEmptyOne();
          return;
        }
        res.forEach((element: any) => {
          element.ifSelect = false;
          element.ifShowEdit = true;
          element.ifShowCorrect = false;
          element.ifShowAnswer = true;
          element.ifShowAnswerBtn = true;
          element.ifShowAnswerResult = false;
          element.ifShowAnswerJiexi = false;
          // element.data.forEach((ele: any) => {
          //   if (ele.type == "多选" && !ele.answer) {
          //     ele.answer = [];
          //   }
          // });
        });
        this.data = res;
        if (type && type == "新增") {
          this.questionIndex = this.data.length - 1;
          this.getDetail();
          this.countHeight();
        } else {
          this.questionIndex = 0;
          this.getDetail();
          this.countHeight();
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private addEmptyOne() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        类别: this.cTab.name,
      },
    };
    GetOptions(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data.push({
          question_template_id: "moni",
          名称: "请对以下采集的" + this.cTab.name + "象进行特征标注。",
          类别: this.cTab.name,
          pic_urls: [],
          data: res,
          ifSelect: false,
          ifShowEdit: true,
          ifShowCorrect: false,
          ifShowAnswer: true,
          ifShowAnswerBtn: true,
          ifShowAnswerResult: false,
          ifShowAnswerJiexi: false,
        });
        if (this.data.length == 1) {
          this.questionIndex = 0;
        } else {
          this.questionIndex = this.data.length - 1;
        }
      })
      .catch(() => {
        loading.close();
      });
    this.countHeight();
  }
  private getDetail() {
    if (this.data[this.questionIndex].data) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        question_template_id:
          this.data[this.questionIndex].question_template_id,
      },
    };
    GetTem(this, params, loading)
      .then((res: any) => {
        loading.close();
        // this.data = res;
        res.data.forEach((ele: any) => {
          if (ele.type == "多选" && !ele.answer) {
            ele.answer = [];
          }
        });
        let arr = JSON.parse(JSON.stringify(this.data));
        let obj = { ...this.data[this.questionIndex], ...res };
        arr[this.questionIndex] = obj;
        this.data = arr;
        this.$forceUpdate();
      })
      .catch(() => {
        loading.close();
      });
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();

        this.addOne(res.full_file_url);
      })
      .catch(() => {
        loading.close();
      });
  }
  private delOne() {
    if (this.data[this.questionIndex].question_template_id == "moni") {
      this.data.splice(this.questionIndex, 1);
      if (this.data.length == 0) {
        this.addEmptyOne();
      } else {
        this.IndexChange(this.questionIndex - 1);
      }
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      data: {
        id: this.data[this.questionIndex].question_template_id,
      },
    };
    DeleteZicai(this, params, loading)
      .then(() => {
        loading.close();
        this.$message.success("删除成功");
        this.data.splice(this.questionIndex, 1);
        if (this.data.length == 0) {
          this.addEmptyOne();
        } else {
          this.IndexChange(0);
        }

        // this.getData();
      })
      .catch(() => {
        loading.close();
      });
  }
  private addOne(url: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        类别: this.cTab.name,
      },
    };
    GetOptions(this, params, loading)
      .then((res: any) => {
        res.forEach((ele: any) => {
          if (ele.type == "多选" && !ele.answer) {
            ele.answer = [];
          } else {
            ele.answer = "";
          }
        });
        const params2: any = {
          名称: "请对以下采集的" + this.cTab.name + "象进行特征标注。",
          类别: this.cTab.name,
          pic_urls: url,
          data: res,
        };
        AddZicai(this, params2)
          .then((d: any) => {
            loading.close();
            this.$message.success("新增成功");
            this.data[this.questionIndex] = {
              question_template_id: d.question_template_id,
              ifSelect: false,
              ifShowEdit: true,
              ifShowCorrect: false,
              ifShowAnswer: true,
              ifShowAnswerBtn: true,
              ifShowAnswerResult: false,
              ifShowAnswerJiexi: false,
            };
            this.IndexChange(this.data.length - 1);
            // this.getData("新增");
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    // if (this.$route.query.type) {
    //   this.cTab = this.$route.query.type;
    // }
    this.getData();
    window.onresize = () => {
      //屏幕尺寸变化就重新计算时间轴
      return (() => {
        this.countHeight();
      })();
    };
  }
}
